import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditMasterCountryVat = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###",defaultMessage:"Edit Master Country Vat" }));
  const history = useHistory();
  const [country, setCountry] = useState();
  const [currencyUnit, setCurrencyUnit] = useState();
  const [countryVatPercent, setCountryVatpercent] = useState();
  const [displayOrder, setDisplayOrder] = useState(0)
  const [state, setState] = useState(true);
  const { user, setUser } = useState; 

  const AlertError = (message) => {
    Swal.fire("Master Country Vat!", message, "error");
  };

  useEffect(() => {
    setCountry(props.location.state.row.country);
    setCurrencyUnit(props.location.state.row.currencyUnit);
    setCountryVatpercent(props.location.state.row.countryVatPercent);
    setState(props.location.state.row.enabled);
    setDisplayOrder(props.location.state.row.display_order);

  }, []);

  const handleChangeSwitch = () => {
    setState(!state);
  };
  const onSubmit = async (data) => {
    if (country === undefined || country === "") {
      return AlertError("please insert country name.");
    }

    if (currencyUnit === undefined || currencyUnit === "") {
      return AlertError("please insert currency unit.");
    }

    if (countryVatPercent === undefined || countryVatPercent === "") {
        return AlertError("please insert vat percentage.");
      }

    
      
    var events = {
      country,
      currencyUnit,
      countryVatPercent,
      enabled: state,
      display_order: displayOrder === 0 ? 0 : displayOrder,
    };

    let apiUrls = `${baseURLV1}/dynamic/countryVats/${props.location.state.row.id}`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Edit !",
          "Your can not update group. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Edit Master Country Vat "></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Country Name" })}:{" "}
            </p>
            <input
              name="country"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Currency Unit" })}:{" "}
            </p>
            <input
              name="currencyUnit"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={currencyUnit}
              onChange={(e) => setCurrencyUnit(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: '25px' }}>
            <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
              <span style={{ color: "red" }}>
                *
            </span>
            {intl.formatMessage({ id: "###",defaultMessage:"Country Vat Percentage" })}:{' '}
            </p>
            <input
              name="countryVatPercent"
              type="number"
              style={{
                height: '38px',
                width: '530px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              value={countryVatPercent}
              onChange={(e) => setCountryVatpercent(e.target.value)
              }
            />
          </div>

         
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/MasterCountryVat">
              <button type="button" className="btn btn-secondary wbt mr-5">
              {intl.formatMessage({ id: "###",defaultMessage:"Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
            {intl.formatMessage({ id: "###",defaultMessage:"Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
